import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ra-test-env-block',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './test-env-block.component.html',
  styleUrls: ['./test-env-block.component.scss'],
})
export class TestEnvBlockComponent {}
